import React, { useContext, useRef, useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ProfileSection } from "../../context/ProfileContext";
import { withRouter } from "react-router-dom";
import { changePassword } from "../../api";
import Cookies from "js-cookie";
import { Alert } from "../";
import { useTranslation } from "react-i18next";
import { FiLock, FiArrowRight, FiCheck, FiAlertCircle } from "react-icons/fi";

const ChangePasswordComp = (props) => {
  const { t } = useTranslation();
  const token = Cookies.get("token");
  const form = useRef(null);
  const { ProfileShowHideFunc } = useContext(ProfileSection);
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const initialChangePassworValues = {
    current_password: "",
    new_password: "",
    confirmPass: "",
  };

  const submitChangePasswordForm = () => {
    const formData = new FormData(form.current);
    changePassword(formData, token)
      .then((res) => {
        if (res.data.message === "OK") {
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("رمز جدید با موفقیت ثبت شد."),
            type: "Success",
          }));
          setTimeout(() => {
            ProfileShowHideFunc("firstPage");
          }, 3000);
        } else {
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: res.data.message_dialect || t("خطایی رخ داده است"),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 3000);
        }
      })
      .catch((err) => {
        if (err.response) {
          // Get error message from API
          const apiMessage = err.response.data?.message_dialect || 
                             err.response.data?.message || 
                             err.response.data?.error ||
                             "";
          
          console.log("API Error Message:", apiMessage); // Debug to see exact message
          
          if (err.response.status === 400) {
            // Check if message contains "اقلام هویتی" or use default
            let userMessage;
            
            if (apiMessage.includes("اقلام هویتی") || apiMessage.includes("مطابقت ندارند")) {
              userMessage = t("رمز عبور فعلی صحیح نمی باشد");
            } else if (apiMessage) {
              userMessage = apiMessage;
            } else {
              userMessage = t("رمز عبور فعلی صحیح نمی باشد");
            }
            
            setShowAlert((prevState) => ({
              ...prevState,
              show: true,
              message: userMessage,
              type: "Error",
            }));
            setTimeout(() => {
              setShowAlert((prevState) => ({
                ...prevState,
                show: false,
              }));
            }, 4000);
          } else if (err.response.status === 403) {
            Cookies.remove("token");
            props.history.push("/login");
            setShowAlert((prevState) => ({
              ...prevState,
              show: true,
              message: t("نشست شما منقضی شده است. لطفا مجددا وارد شوید."),
              type: "Error",
            }));
            setTimeout(() => {
              setShowAlert((prevState) => ({
                ...prevState,
                show: false,
              }));
            }, 3000);
          } else {
            setShowAlert((prevState) => ({
              ...prevState,
              show: true,
              message: apiMessage || t("خطایی رخ داده است. لطفا مجددا تلاش کنید."),
              type: "Error",
            }));
            setTimeout(() => {
              setShowAlert((prevState) => ({
                ...prevState,
                show: false,
              }));
            }, 3000);
          }
        } else {
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("مشکل در ارتباط با سرور. لطفا بررسی کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 3000);
        }
      });
  };

  const validationSchemaChangePassword = Yup.object({
    current_password: Yup.string().required(t("رمز عبور را وارد کنید.")),
    new_password: Yup.string()
      .required(t("رمز عبور جدید را وارد کنید."))
      .min(8, t("رمز عبور باید حداقل 8 کاراکتر باشد")),
    confirmPass: Yup.string()
      .required(t("تکرار رمز عبور جدید را وارد کنید."))
      .oneOf([Yup.ref("new_password"), null], t("رمزهای عبور مطابقت ندارند")),
  });

  return (
    <div className="setting-container" style={{ minHeight: "90vh" }}>
      <h2 className="setting-title">{t("تغییر رمز عبور")}</h2>

      {/* Forgot Password Link */}
      <div className="forgot-password-link" onClick={() => props.history.push("/forgotpassword")}>
        <FiAlertCircle size={18} />
        <span>{t("فراموشی رمز عبور؟")}</span>
      </div>

      {/* Form */}
      <Formik
        initialValues={initialChangePassworValues}
        onSubmit={submitChangePasswordForm}
        validationSchema={validationSchemaChangePassword}
      >
        {(formProps) => (
          <Form ref={form}>
            {/* Current Password */}
            <div className="setting-item" style={{ flexDirection: "column", alignItems: "stretch", gap: "12px" }}>
              <div className="setting-item-label">
                <FiLock size={18} />
                <span>{t("رمز عبور فعلی")}</span>
              </div>
              <input
                type="password"
                placeholder={t("رمز عبور فعلی")}
                name="current_password"
                onChange={formProps.handleChange}
                onBlur={formProps.handleBlur}
                className="setting-input"
              />
              <ErrorMessage name="current_password">
                {(errMsg) => (
                  <div className="setting-error">{errMsg}</div>
                )}
              </ErrorMessage>
            </div>

            {/* New Password */}
            <div className="setting-item" style={{ flexDirection: "column", alignItems: "stretch", gap: "12px" }}>
              <div className="setting-item-label">
                <FiLock size={18} />
                <span>{t("رمز عبور جدید")}</span>
              </div>
              <input
                type="password"
                placeholder={t("رمز عبور جدید")}
                name="new_password"
                onChange={formProps.handleChange}
                onBlur={formProps.handleBlur}
                className="setting-input"
              />
              <ErrorMessage name="new_password">
                {(errMsg) => (
                  <div className="setting-error">{errMsg}</div>
                )}
              </ErrorMessage>
            </div>

            {/* Confirm Password */}
            <div className="setting-item" style={{ flexDirection: "column", alignItems: "stretch", gap: "12px" }}>
              <div className="setting-item-label">
                <FiLock size={18} />
                <span>{t("تکرار رمز عبور جدید")}</span>
              </div>
              <input
                type="password"
                placeholder={t("تکرار رمز عبور جدید")}
                name="confirmPass"
                onChange={formProps.handleChange}
                onBlur={formProps.handleBlur}
                className="setting-input"
              />
              <ErrorMessage name="confirmPass">
                {(errMsg) => (
                  <div className="setting-error">{errMsg}</div>
                )}
              </ErrorMessage>
            </div>

            {/* Buttons */}
            <div className="setting-buttons">
              <button
                type="button"
                className="setting-back-btn"
                onClick={() => ProfileShowHideFunc("setting")}
                style={{ background: "var(--bg-white)", color: "var(--text-primary)", border: "2px solid var(--border-color)" }}
              >
                <FiArrowRight size={18} />
                <span>{t("بازگشت")}</span>
              </button>
              <button type="submit" className="setting-back-btn">
                <FiCheck size={18} />
                <span>{t("ذخیره")}</span>
              </button>
            </div>
          </Form>
        )}
      </Formik>

      {showAlert.show && (
        <Alert message={showAlert.message} type={showAlert.type} />
      )}
    </div>
  );
};

const ChangePassword = withRouter(ChangePasswordComp);

export { ChangePassword };